import { render, staticRenderFns } from "./SystemTeamDetail.vue?vue&type=template&id=c342b54c&scoped=true&lang=pug&"
import script from "./SystemTeamDetail.vue?vue&type=script&lang=js&"
export * from "./SystemTeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./SystemTeamDetail.vue?vue&type=style&index=0&id=c342b54c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c342b54c",
  null
  
)

/* custom blocks */
import block0 from "./SystemTeamDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports